import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { Text } from "@/components/Text";
import { agoDate } from "@/core/dates";
import { IDCCreateTask } from "@/data/tasks";
import { Flex, Tooltip } from "@/eworkitComponents/index";
import { IListItemProps, ListItem } from "@/views/components/List";
import { TaskPriorityLabel } from "@/views/Tasks/List/components/TaskPriorityLabel";

export interface IDCCListItemProps extends IListItemProps {
  task: IDCCreateTask;
}

export const DCCListItem: FC<IDCCListItemProps> = memo(({ task, ...props }) => {
  const { t } = useTranslation("session");
  const title = task.entity.title;
  const workerName = task.entity.designatedCandidate?.workerName;

  return (
    <ListItem {...props}>
      <Flex width={12} direction="column" justify="center">
        <Flex width={12} justify="space-between" innerMargin="sm">
          <Text color="grey1">{t(`TASKS.TYPE.${task.type}`)}</Text>
          <Tooltip content={t(`TASKS.PRIORITY.${task.priority}`)} placement="top">
            <TaskPriorityLabel priority={task.priority}>{agoDate(task.createdDate)}</TaskPriorityLabel>
          </Tooltip>
        </Flex>
        <Flex width={12}>{`${title} / ${workerName}`}</Flex>
      </Flex>
    </ListItem>
  );
});
